import(/* webpackMode: "eager" */ "C:\\Users\\Avenir-IT\\Documents\\Pizza App\\pizza-app-fe\\src\\app\\global-error.tsx");
